import React from 'react';
import { useDialogKeyboard, DialogKeyboardConfig } from 'lib/hooks/useDialogKeyboard';
import { closeModal, showModal } from './index';
import './tips.scss';

const TipsModal = ({ content, confirmCallback, confirmText = '确定', title, keyboard }: {
  content: React.ReactNode;
  confirmCallback?: () => void;
  confirmText?: string;
  title?: string;
  keyboard?: DialogKeyboardConfig;
}) => {
  const confirm = () => {
    closeModal();
    confirmCallback?.();
  };

  useDialogKeyboard({
    onEnter: keyboard?.onEnter ?? confirm,
    onEscape: keyboard?.onEscape ?? closeModal,
    allowEnterInInput: keyboard?.allowEnterInInput,
  });

  return (
    <div className="tips-modal">
      <div className="tips-modal__close" onClick={closeModal}></div>
      {title ? <div className="tips-modal__title">{title}</div> : null}
      {Array.isArray(content) ? (
        <div className="tips-modal__contents-container">
          {content.map((item, index) => (
            <div key={index} className="tips-modal__contents-container__content">
              {item}
            </div>
          ))}
        </div>
      ) : (
        <div className="tips-modal__content">{content}</div>
      )}
      <div className="tips-modal__btn" onClick={confirm}>
        {confirmText}
      </div>
    </div>
  );
};

TipsModal.show = (params) => {
  showModal(<TipsModal {...params} />);
};

export default TipsModal;
